import { Dispatch } from "@reduxjs/toolkit";
import { setFeatureType, setFeatures } from "./reducer";
import {
  FeatureState,
  FeatureTypeState,
} from "../../utils/interfaces/features";

export const featuresActionDispatch = (dispatch: Dispatch) => ({
  setFeatures: (features: FeatureState) => dispatch(setFeatures(features)),
  setFeatureType: (featureType: FeatureTypeState) =>
    dispatch(setFeatureType(featureType)),
});
